import { memo } from "react";
import HeroFilter from "./HeroFilter";
import "./hero.css";

const Hero = memo(({ data }) => {
  const CmsData = data;
  return (
    <section className="home-one home1-overlay">
      <div className="video-background">
        <img
          src="/assets/images/home/home-banner.webp"
          alt="home-new-bg"
          className="hero-bg-image desktop-hero"
          loading="eager"
          decoding="async"
        />
        <img
          src="/assets/images/home/home-banner-mobile.jpg"
          alt="home-banner"
          className="hero-bg-image mobile-hero"
          loading="eager"
          decoding="async"
        />
        {/* <video autoPlay muted loop id="video-background">
          <source src="/assets/media/bg.mp4" type="video/mp4" />
          Your browser does not support the video tag.
        </video> */}
      </div>
      <div className="container">
        <div className="row posr">
          <div className="col-lg-10 offset-lg-1">
            <HeroFilter data={CmsData} />
          </div>
        </div>
      </div>
      {/* End .container */}

      {/* <div className="mouse_scroll">
        <a href="#feature-property">
          <div className="icon">
            <h4>Scroll Down</h4>
            <p>to discover more</p>
          </div>
          <div className="thumb">
            <img src="/assets/images/resource/mouse.png" alt="mouse.png" />
          </div>
        </a>
      </div> */}
    </section>
  );
});

export default Hero;
